import { useLayoutEffect, useState } from 'react';

const initialWindowWidth = window.innerWidth,
  initialWindowHeight = window.innerHeight;

export default function useWindowSize() {
  const [size, setSize] = useState([0, 0, 0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      const currentWindowWidth = window.innerWidth;
      const currentWindowHeight = window.innerHeight;
      setSize([
        currentWindowWidth,
        currentWindowHeight,
        initialWindowWidth,
        initialWindowHeight,
      ]);
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}
